import { Action } from "../../../actions/actions";
import { VppsActionTypes } from "../actions/actionTypes";

export function vpps(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case VppsActionTypes.GET_VPPS_SUCCESS:
            return action.payload.vpps;

        default:
            return state;
    }
}

export function vppsLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case VppsActionTypes.GET_VPPS:
            return true;

        case VppsActionTypes.GET_VPPS_FAIL:
        case VppsActionTypes.GET_VPPS_SUCCESS:
            return false;

        default:
            return state;
    }
}

export function currentVppsUsers(
    state: { results: any[]; count: number } = {
        results: [],
        count: 0
    },
    action: Action
) {
    switch (action.type) {
        case VppsActionTypes.GET_VPPS_SUCCESS:
            return action.payload.users;
        default:
            return state;
    }
}
